import type { TechlineAssetEntity } from '../entities';

import { StsBackendOperation } from '../../../sts-backend-operation';
import { buildAssetErrorPayload } from '../helpers';

/** Parameters for marking assets as errored. */
export type MarkErroredParams = {
    /** The assets to mark as ERROR. */
    assets: TechlineAssetEntity[];
};

/**
 * Mark uploading assets as errored when the polling retry threshold has
 * been exceeded. Builds the error payload and sends it to the API so
 * the assets are no longer shown as "uploading" to the user.
 */
export class MarkErrored extends StsBackendOperation {
    /**
     * Mark the given assets as errored via the API.
     *
     * @param params - the assets to mark as errored
     */
    async exec(params: MarkErroredParams): Promise<void> {
        const { assets } = params;
        const errorEntries = buildAssetErrorPayload(assets);

        if (errorEntries.length) {
            await this.client.updateAssets({
                assetsBody: { assets: errorEntries },
            });
        }
    }
}
